import { Store } from "pullstate";

export const SignupStepState = new Store(0);
